/** How a Discover card draws its cover and where it opens, by kind. */
import type {ReactNode} from 'react';
import {labelOf, updatedAt, type DiscoverItem} from './useDiscoverData';
import {favoriteKind} from './favorites';
import FavoriteCover from './FavoriteCover';
import {CoverArt} from './CoverArt';

export type CoverOf = (item: DiscoverItem, height?: number) => ReactNode;

/** A model's shelf cover: its avatar or canvas snapshot. */
export const modelCover = (item: DiscoverItem, height?: number) =>
    <CoverArt id={item._id} label={labelOf(item)} src={item.$icon} version={updatedAt(item)} height={height}/>;

/** A favorite's cover: a model's own, else its kind's (#2293). */
export function favoriteCover(item: DiscoverItem, height?: number) {
    const kind = favoriteKind(item);
    return kind === 'model' ? modelCover(item, height) : <FavoriteCover item={item} kind={kind} height={height}/>;
}

export const modelRoute = (item: DiscoverItem) => `/build/${item._id}`;
